import { ReactComponentLayout } from '~/src/layouts';
import * as React from 'react';
export default {
  ReactComponentLayout,
  React
};